import { render } from "./TrackSorter.vue?vue&type=template&id=fd6841e6&ts=true"
import script from "./TrackSorter.vue?vue&type=script&lang=ts"
export * from "./TrackSorter.vue?vue&type=script&lang=ts"

import "./TrackSorter.vue?vue&type=style&index=0&id=fd6841e6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__